import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const main = async (data: any) => {
  return httpRequest.get("/api/dashboard", data);
};
